export default "__VITE_ASSET__8614a382__"